var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 84,
    viewBox: "0 0 81 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1669 83.3091L41.1618 83.3128C40.8837 83.5147 40.6099 83.7135 40.3409 83.9091C40.0719 83.7135 39.798 83.5147 39.5199 83.3128L39.5148 83.3091C37.6158 81.9305 35.5101 80.4019 33.2829 78.6821L23.2356 70.0113C10.5307 57.5485 -1.8987 38.1878 0.241858 6.51596C13.652 1.80494 32.4062 0.20621 40.3292 0.000300261L40.3409 0L40.3522 0.000292597C48.2753 0.206202 67.0297 1.80494 80.4399 6.51596C82.0854 30.8629 75.1214 47.9136 66.0742 60.1436C59.758 68.6818 52.4023 74.9027 46.1624 79.6273C44.39 80.9693 42.7106 82.1885 41.1669 83.3091Z",
    fill: "#1956A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3408 83.909C40.3408 83.909 40.3408 83.909 40.3408 83.909C40.0718 83.7134 39.7979 83.5146 39.5198 83.3128L39.5148 83.3091C37.6157 81.9305 35.51 80.4018 33.2828 78.6821L23.2355 70.0112C16.0789 62.9909 9.00963 53.7819 4.58276 41.4166H40.3408V83.909Z",
    fill: "#144586"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.099 41.4167H40.3408V0L40.3522 0.000291963C48.2752 0.206201 67.0296 1.80494 80.4398 6.51596C81.3752 20.3555 79.5287 31.8375 76.099 41.4167Z",
    fill: "#144586"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9814 40.794C44.7129 40.0948 46.7208 37.7518 46.7208 34.9693C46.7208 31.6348 43.8375 28.9318 40.2808 28.9318C36.7241 28.9318 33.8408 31.6348 33.8408 34.9693C33.8408 37.9373 36.1253 40.4051 39.1357 40.9116L35.451 49.0568H45.916L41.9814 40.794Z",
    fill: "#FFA05C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.0230eb90257440e8520b9c75089786c7.svg";
export { ForwardRef as ReactComponent };